import { ICompany, ICompanyStatus } from "@/features/companies/types"
import { CompanyItemModel } from "../models/companyItemModel"

/** Maps the web-api companies list row onto the ICompany the companies feature is built on. */
export const parseCompanyItem = (item: CompanyItemModel): ICompany =>
  ({
    uid: item.uid,
    name: item.name,
    reference: item.vatNumber,
    domain: item.domain,
    host: item.host,
    country: item.country,
    status: item.status as ICompanyStatus,
    created: item.created,
    company_type: item.companyType,
    is_external: item.isExternal,
    is_supplier: item.isSupplier,
    is_customer: item.isCustomer,
    notice_period: item.noticePeriod,
    fa_start_date: item.faStartDate,
    fa_end_date: item.faEndDate,
    tags: item.tags.map((tag) => ({
      uid: tag.uid,
      name: tag.name,
      background_color: tag.backgroundColor,
      text_color: tag.textColor,
      created: tag.created,
      source: tag.source,
      groups: tag.groups.map((group) => ({
        uid: group.uid,
        name: group.name,
        background_color: group.backgroundColor,
        text_color: group.textColor,
        is_global: group.isGlobal,
      })),
    })),
  }) as ICompany
